export const shipmentFormData = (others) => {
  return {
    ...others,
  }
}
